<script lang="ts" setup>
import { useDialogTimeSlotStore } from '@/store/timeslot/dialogTimeSlotStore'

const dialogStore = useDialogTimeSlotStore()
</script>
<template>
  <div>
    <v-dialog
      v-model="dialogStore.dialogYouNeedProfilesAndAddress"
      persistent
      width="380"
      transition="dialog-top-transition"
    >
      <v-card rounded="xl" class="bg-white pb-8">
        <v-card-title
          class="alert-title d-flex pa-3 justify-center w-full align-center"
        >
          <span>{{
            $t('dashboard.time-slot.dialogYouNeedProfileAndAddress.title')
          }}</span>

          <v-btn
            @click="dialogStore.dialogYouNeedProfilesAndAddress = false"
            variant="outlined"
            density="compact"
            size="small"
            class="position-absolute"
            style="right: 10px"
            icon="$close"
          />
        </v-card-title>

        <div class="px-2">
          <div class="d-flex flex-column ga-10 pt-10 content-msg">
            <div class="d-flex justify-center">
              <v-img
                width="93"
                height="93"
                src="@/assets/warning-profile.png"
              />
            </div>
            <div class="d-flex flex-column ga-2">
              <div class="alert-create-title">
                {{
                  $t(
                    'dashboard.time-slot.dialogYouNeedProfileAndAddress.profileAdd',
                  )
                }}
              </div>
              <div class="alert-create-desc">
                {{
                  $t(
                    'dashboard.time-slot.dialogYouNeedProfileAndAddress.message',
                  )
                }}
              </div>
            </div>
          </div>

          <div class="d-sm-flex justify-center mt-10 ga-1">
            <v-btn
              :to="{ name: 'DashboardAddress' }"
              class="w-sm-auto w-100"
              variant="flat"
              color="#E0E0E0"
            >
              <span
                style="
                  color: #757575;
                  font-size: 14px;
                  line-height: 140%;
                  font-weight: 600;
                "
              >
                {{
                  $t(
                    'dashboard.time-slot.dialogYouNeedProfileAndAddress.goToAddresses',
                  )
                }}
              </span>
            </v-btn>
            <v-btn
              :to="{ name: 'DashboardProfile' }"
              class="w-sm-auto w-100 text-white mt-2 mt-sm-0"
              variant="flat"
              color="#12C29B"
            >
              <span>{{
                $t(
                  'dashboard.time-slot.dialogYouNeedProfileAndAddress.goToProfiles',
                )
              }}</span>
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped lang="scss">
.alert-title {
  color: #007058;
  font-weight: 600;
  line-height: 140%;
  letter-spacing: -0.72px;
  background-color: #0299781a;
}

.content-msg {
  background-image: url('@/assets/background.png');
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 100%;
}

.alert-create-title {
  color: #007058;
  font-weight: 600;
  font-size: 16px;
  letter-spacing: -0.64px;
  text-align: center;
}

.alert-create-desc {
  color: #616161;
  font-weight: 500;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: -0.42px;
  text-align: center;
}
</style>
